module.exports = __webpack_public_path__ + "img/1.b944c679.png";